import { normalizeUsername } from '#app/utilities/normalizeUsername.js';
import { getRoute } from '@contra/routes';

export const getIndependentPortfolioUrl = ({
  username = '',
}: {
  username?: string;
}) => {
  if (!username) {
    return getRoute('/me');
  }

  const normalizedUsername = username ? normalizeUsername(username) : undefined;

  return `https://${normalizedUsername}.contra.com`;
};
